import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { analyticsService } from '../../services/analytics.service';
import { requestCache } from '../../utils/requestCache';

// Types
export interface Analytics {
  views: number;
  portfolioItems: number;
  inquiries: number;
  followers: number;
}

export interface AnalyticsState {
  data: Analytics | null;
  isLoading: boolean;
  error: string | null;
  lastFetched: number | null;
}

// dsomechangestotriggerdeployment
// Initial state
const initialState: AnalyticsState = {
  data: null,
  isLoading: false,
  error: null,
  lastFetched: null,
};

// Async thunks
export const fetchAnalytics = createAsyncThunk(
  'analytics/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const response = await requestCache.get('fetchAnalytics', () =>
        analyticsService.getDashboardStats()
      );
      if (response.success && response.data) {
        return response.data;
      }
      return rejectWithValue('Failed to fetch analytics');
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch analytics');
    }
  }
);

// Slice
const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    clearAnalytics: (state) => {
      state.data = null;
      state.error = null;
      state.lastFetched = null;
    },
    updateAnalytics: (state, action: PayloadAction<Partial<Analytics>>) => {
      if (state.data) {
        state.data = { ...state.data, ...action.payload };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAnalytics.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAnalytics.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.lastFetched = Date.now();
      })
      .addCase(fetchAnalytics.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearAnalytics, updateAnalytics } = analyticsSlice.actions;
export default analyticsSlice.reducer;
